import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "txt-center": "" }
const _hoisted_2 = { style: {"padding":"0 10px"} }
const _hoisted_3 = { style: {"margin-bottom":"36px","margin-top":"-10px"} }
const _hoisted_4 = { "txt-center": "" }
const _hoisted_5 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      "custom-class": "App-User-Profile-Modal App-Unpadded",
      "model-value": _ctx.isModalOpen,
      width: "550px",
      "show-close": _ctx.showClose,
      "close-on-click-modal": _ctx.showClose,
      onOpen: _ctx.opened,
      title: "Work Experience",
      center: "",
      "append-to-body": true,
      "lock-scroll": true,
      "open-delay": 200,
      "close-delay": 200,
      "before-close": _ctx.closeModal,
      "close-on-press-escape": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            "is-block": "",
            icon: "el-icon-check",
            onClick: _ctx.submit,
            size: "large",
            type: "primary",
            disabled: _ctx.loading || _ctx.disabled
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Save Experience ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_scrollbar, {
          always: true,
          "max-height": "600px"
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_el_image, {
                    style: `width: 150px;`,
                    src: _ctx.img
                  }, null, 8, ["src"]),
                  _cache[1] || (_cache[1] = _createElementVNode("p", null, "Tell us about your professional experience", -1))
                ])
              ]),
              _createVNode(_component_el_form, {
                onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                class: "App-Styled-Form",
                "label-position": 'top',
                "label-width": "100px",
                model: _ctx.form,
                style: {"margin-top":"12px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.experience, (exp, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createVNode(_component_app_section_divider, null, {
                        default: _withCtx(() => [
                          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "el-icon-document" }, null, -1)),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$filters.capitalize(exp.organisation || "Work Experience")), 1),
                          (index > 0)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                onClick: ($event: any) => (_ctx.removeExperience(index)),
                                icon: "el-icon-delete",
                                circle: "",
                                size: "mini"
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, {
                        prop: "organisation",
                        label: "Organisation"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "EX: E4T",
                            modelValue: _ctx.form.experience[index].organisation,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.form.experience[index].organisation) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, {
                        prop: "role",
                        label: "Role"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            placeholder: "EX: UI/UX Designer",
                            modelValue: _ctx.form.experience[index].role,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.form.experience[index].role) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_row, { gutter: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                prop: "From",
                                label: "Start Date"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    type: "month",
                                    format: "MM/YYYY",
                                    placeholder: "MM/YYYY",
                                    modelValue: _ctx.form.experience[index].from,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.experience[index].from) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (_ctx.stillThere[index] !== true)
                            ? (_openBlock(), _createBlock(_component_el_col, {
                                key: 0,
                                span: 12
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "To",
                                    label: "End Date"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_date_picker, {
                                        type: "month",
                                        format: "MM/YYYY",
                                        placeholder: "MM/YYYY",
                                        modelValue: _ctx.form.experience[index].to,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form.experience[index].to) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_el_checkbox, {
                                  onChange: ($event: any) => {
                        if (_ctx.stillThere[index])
                          _ctx.form.experience[index].to = undefined;
                      },
                                  modelValue: _ctx.stillThere[index],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.stillThere[index]) = $event),
                                  label: "Currently working at the organization.",
                                  size: "small"
                                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_button, {
                      type: "info",
                      "is-borderless": "",
                      round: "",
                      onClick: _ctx.addExperience,
                      size: "small",
                      icon: "el-icon-plus"
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("Add Experience", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["model"])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value", "show-close", "close-on-click-modal", "onOpen", "before-close"])
  ]))
}